import { combineReducers } from "redux";
import { notification } from './notification';


export default combineReducers ({
    notification
})


// WEBPACK FOOTER //
// ./src/reducers/index.js